/**
 * ==========================================================
 * ECOMA FOUNDERS
 * Premium Scroll Animations + Parallax
 * ==========================================================
 */

(() => {

  function initFounders(scope = document) {

    const sections = scope.querySelectorAll(".ecoma-founders");

    sections.forEach((section) => {

     
      const badge = section.querySelector(".founders-floating-badge");

      /* ------------------------------------
         Reveal Animation
      ------------------------------------ */

      const revealItems = section.querySelectorAll(
        ".founders-media, .founders-content, .founders-quote-card, .founders-footer"
      );

      revealItems.forEach((item) => {

        item.classList.add("founders-reveal");

      });

      const observer = new IntersectionObserver(

        (entries) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              entry.target.classList.add("is-visible");

            }

          });

        },

        {
          threshold: 0.18
        }

      );

      revealItems.forEach((item) => {

        observer.observe(item);

      });

      /* ------------------------------------
         Image Parallax
      ------------------------------------ */

      if (image) {

        section.addEventListener("mousemove", (e) => {

          if (window.innerWidth < 991) return;

          const rect = section.getBoundingClientRect();

          const x = (e.clientX - rect.left) / rect.width - 0.5;
          const y = (e.clientY - rect.top) / rect.height - 0.5;

          image.style.transform =
            `translate(${x * 12}px, ${y * 12}px) scale(1.02)`;

          if (badge) {

            badge.style.transform =
              `translate(${x * 8}px, ${y * 8}px)`;

          }

        });

        section.addEventListener("mouseleave", () => {

          image.style.transform = "";

          if (badge) {

            badge.style.transform = "";

          }

        });

      }

    });

  }

  document.addEventListener("DOMContentLoaded", () => {

    initFounders();

  });

  document.addEventListener("shopify:section:load", (e) => {

    initFounders(e.target);

  });

})();